import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';
import { FpjsProvider } from '@fingerprintjs/fingerprintjs-pro-react';

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(HttpApi)
  .init({
    react: {
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'b', 'span'],
    },
    supportedLngs: ['en', 'ru', 'pl', 'fr'],
    fallbackLng: "en",
    detection: {
      order: ['cookie', 'htmlTag', 'localStorage', 'path', 'subdomain'],
      caches: ['cookie']
    },
    backend: {
      loadPath: '/locales/{{lng}}/translation.json',
    }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <FpjsProvider
      loadOptions={{
        apiKey: "Yx0985hTx4W4bKHWHoEn",
        region: "eu"
      }}
    >
      <App />
    </FpjsProvider>
  </React.StrictMode>
);
